// 굿즈 상세 실시간 미리보기(docs/build/16 §3) — 웹의 **실제 컴포넌트**를 iframe 으로 띄운다.
//
// 목업을 관리자에 다시 그리지 않는 이유: 렌더 경로가 둘이 되면 운영자가 승인한 화면과
// 아이가 보는 화면이 갈린다(CLAUDE.md — 같은 값을 쓰는 렌더러를 한 곳만 고치지 말 것).
// 여기서는 초안을 postMessage 로 넘기기만 하고, 그리는 일은 전부 웹이 한다.
import { useEffect, useRef, useState } from "react";
import { contentBase } from "../lib/contentApi";
import type { GoodsProduct } from "@greg-chick/shared";

/** 웹이 기대하는 형태(GoodsView) — 슬롯이 아직 매니페스트에 없을 수 있어 URL 을 직접 넘긴다. */
export interface PreviewProduct extends GoodsProduct {
  imageUrls: string[];
}

export function GoodsPreviewFrame({ product }: { product: PreviewProduct }) {
  const frameRef = useRef<HTMLIFrameElement>(null);
  const [ready, setReady] = useState(false);
  const src = `${contentBase()}/goods-preview`;

  // iframe 로드 완료 신호를 기다린다 — 먼저 쏘면 리스너가 붙기 전이라 첫 메시지를 잃는다.
  useEffect(() => {
    const onMsg = (e: MessageEvent) => {
      if ((e.data as { type?: string })?.type === "goods-preview-ready") setReady(true);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  // 입력할 때마다 최신 초안 전송. targetOrigin 을 웹 출처로 못박아 다른 프레임에 새지 않게.
  useEffect(() => {
    if (!ready) return;
    frameRef.current?.contentWindow?.postMessage({ type: "goods-preview", product }, contentBase());
  }, [ready, product]);

  return (
    <div className="goods-preview-frame">
      <div className="goods-preview-frame__bar">
        <span>미리보기</span>
        <span className="hint">아이가 보는 실제 화면 (모바일 폭)</span>
      </div>
      <iframe
        ref={frameRef}
        className="goods-preview-frame__frame"
        src={src}
        title="굿즈 상세 미리보기"
        onLoad={() => frameRef.current?.contentWindow?.postMessage({ type: "goods-preview", product }, contentBase())}
      />
    </div>
  );
}
